import { Layers } from "appworks/graphics/layers/layers";
import { ControlFactory } from "appworks/ui/factories/control-factory";
import { AgsCreditSizeStepperControl } from "../ags-credit-size-stepper-control";

export class AgsCreditSizeStepperControlFactory implements ControlFactory {
    public filter(layer: Layers): boolean {
        return (
            layer.getFlexiButton("credit_size_stepper_down") != null &&
            layer.getFlexiButton("credit_size_stepper_up") != null &&
            layer.getFlexiText("credit_size_stepper_value") != null
        );
    }

    public build(layer: Layers): AgsCreditSizeStepperControl[] {
        return [
            new AgsCreditSizeStepperControl(
                layer.getFlexiButton("credit_size_stepper_down"),
                layer.getFlexiButton("credit_size_stepper_up"),
                layer.getFlexiText("credit_size_stepper_value")
            )
        ];
    }
}
